<template>
  <div class="user-page">
    <page-title>
      {{ $t('labels.my_profile') }}
    </page-title>
    <el-tabs v-model="activeTab" v-if="user">
      <el-tab-pane :label="$t('students.profile')" name="user">
        <user-page :user="user" isMyProfile></user-page>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import UserPage from '@/components/Users/Page/UserSummary.vue'
  export default {
    components: {
      UserPage
    },
    props: ['id'],
    data () {
      return {
        activeTab: 'user'
      }
    },
    computed: {
      user () {
        return this.$store.state.user.user
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .user-page {
    .el-tabs {
      &__nav-wrap {
        padding: 0 30px;
        background: #fff;
        border-radius: $global-radius;
        box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);

        &:after {
          display: none;
        }
      }

      &__content {
        overflow: visible;
      }

      &__item {
        font-weight: 400;
        color: $secondary-font-color;

        &.is-active {
          color: #1989fa;

          a {
            color: #1989fa;
          }
        }

        &:focus.is-active.is-focus:not(:active) {
          box-shadow: none;
        }
      }

      &__active-bar {
        height: 3px;
        background-color: #1989fa;
      }
    }
  }

  .user-page-not-found {
    a {
      color: $link-color;
    }
  }
</style>

